import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import type { CaptainOptions } from 'src/common/types/CaptainOptions';
import getCaptainOption from 'src/listing/utils/getCaptainOption';
import Icon from 'src/common/components/IconDS22';
import Typography from 'src/common/components/Typography';
import styles from './CaptainOption.module.scss';

export type CaptainOptionProps = {
  captainOptions: CaptainOptions;
};

const CaptainOption: FC<CaptainOptionProps> = ({
  captainOptions,
}) => {
  const [t] = useTranslation('listing-page');
  if (!captainOptions) return null;
  const captainedType = getCaptainOption(captainOptions);
  return (
    <div className={styles.root}>
      <Icon
        id="captain"
        size="l"
      />
      <Typography type="h2" size="body-l">
        {t(`captain-option--${captainedType}`)}
      </Typography>
    </div>
  );
};

export default CaptainOption;
